const getAssessmentSet = async (url, abortController, token) => {
  abortController.current = new AbortController();
  const options = {
    signal: abortController.current.signal,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      const errorResponse = await response.json();
      const error = new Error(
        `Failed to fetch assessment set: ${JSON.stringify(errorResponse)} ${response.status}`
      );
      error.status = response.status;
      error.body = errorResponse;
      throw error;
    }
    return response.json();
  } catch (error) {
    const err = new Error("Error while fetching assessment set", { cause: error });
    err.status = error.status;
    throw err;
  }
};

export default getAssessmentSet;
